import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CMSNavigation } from '@common/interfaces';
import css from './styles.module.scss';

interface CMSNavigationExtended extends CMSNavigation {
  iconSvg?: JSX.Element;
}

interface INavigation {
  navigation?: CMSNavigationExtended[];
}

const Navigation: FC<INavigation> = ({ navigation = [] }) => {
  const { pathname } = useLocation();
  return (
    <nav className={css.navigation}>
      {navigation.map(({ icon, iconSvg, link_url, link_title, open_in_new_tab }, idx) => {
        const target = open_in_new_tab ? '_blank' : '_self';
        const isActive = pathname === link_url;
        return (
          <Link to={link_url} key={idx} className={`${css.link} ${isActive ? css.active : ''}`} target={target}>
            {icon && <img src={icon} alt='' />}
            {iconSvg}
            {link_title}
          </Link>
        );
      })}
    </nav>
  );
};

export default Navigation;
